import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Initialize i18n
i18n
  .use(HttpBackend) // Load translations using http (default public/assets/locals/translation.json)
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    fallbackLng: {
	    'en-US':['en'],
	    'en-ES':['es'],
	    'es-MX':['es'],
	    'default':['en']
    },
    debug: true, // Enable debug for development
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translation files
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'], // Detection order
      caches: ['localStorage', 'cookie'], // Where to store the detected language
    },
  });

export default i18n;

